import { Avatar, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { initials } from "../helpers/chatHelpers";
import type { ChatContact } from "../types/chatTypes";

interface ChatHeaderProps {
  contact: ChatContact;
  search: string;
  showSearch: boolean;
  setShowSearch: (value: boolean) => void;
  setSearch: (value: string) => void;
  LeadId?: any;
  leadName?: any;
}

const ChatHeader = ({ contact, search, showSearch, setShowSearch, setSearch, LeadId, leadName }: ChatHeaderProps) => {
  return (
    <div className="bg-white border-b border-gray-100 shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] z-10 relative">
      <div className="flex items-center gap-3 px-4 py-3 md:px-5 md:py-4">
        <div className="relative">
          <Avatar
            sx={{
              width: 46,
              height: 46,
              fontSize: 16,
              fontWeight: 600,
              color: "#2563eb",
              backgroundColor: "#eff6ff",
              border: "1px solid #dbeafe"
            }}
          >
            {leadName ? initials(leadName) : initials(contact.name)}
          </Avatar>
          <span
            className={`absolute bottom-0 right-0 block h-3 w-3 rounded-full border-2 border-white ${contact.online ? "bg-emerald-500" : "bg-gray-300"
              }`}
          />
        </div>

        <div className="flex-1 min-w-0 ml-1">
          <p className="text-[16px] md:text-[17px] font-bold text-gray-800 truncate tracking-tight">{contact.name}</p>
          <div className="mt-0.5 flex items-center gap-1.5">
            <span className="text-[13px] text-gray-500 font-medium">
              {contact.online ? "Online" : "Offline"}
            </span>
          </div>
        </div>

        {showSearch && (
          <div className="flex w-1/3 min-w-[200px] max-w-[300px] items-center gap-2 rounded-full bg-gray-50 px-4 py-2 border border-gray-200 focus-within:ring-2 focus-within:ring-blue-100 focus-within:border-blue-300 transition-all">
            <SearchIcon sx={{ fontSize: 18, color: "#64748b" }} />
            <input
              autoFocus
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search in chat..."
              className="w-full bg-transparent text-[14px] text-gray-800 outline-none placeholder:text-gray-400"
            />
            <button
              onClick={() => {
                setSearch("");
                setShowSearch(false);
              }}
              className="rounded-full flex items-center justify-center h-6 w-6 text-gray-400 hover:bg-gray-200 hover:text-gray-700 transition"
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </button>
          </div>
        )}

        <div className="flex items-center gap-1 ml-2">
          <IconButton
            size="small"
            onClick={() => {
              if (showSearch) {
                setSearch("");
                setShowSearch(false);
              } else {
                setShowSearch(true);
                setSearch("");
              }
            }}
            sx={{
              color: showSearch ? "#2563eb" : "#64748b",
              backgroundColor: showSearch ? "#eff6ff" : "transparent",
              '&:hover': { backgroundColor: '#f1f5f9', color: '#2563eb' }
            }}
          >
            <SearchIcon sx={{ fontSize: 22 }} />
          </IconButton>

          <IconButton
            size="small"
            sx={{ color: "#64748b", '&:hover': { backgroundColor: '#f1f5f9', color: '#2563eb' } }}
          >
            {/* <MoreVertIcon sx={{ fontSize: 22 }} /> */}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
